import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"

import {explorer_action_search, explorer_action_search_count} from "../../../store/actions/explorer";
import leng from "../../../data";

import {
    Grid,
    DataTableSkeleton, Pagination
} from "carbon-components-react";

import FilterSearch from "../../../components/FilterSearch";
import CustomTable from "../../../components/CustomTable";
import {Download20, Launch20} from "@carbon/icons-react";
import {headerInformation} from "../../../components/CustomTable/helpers/tableValuesEdit";


const columns = [
    {name: "filename", title: "File"},
    {name: "download", title: leng.repositorio.formato_table_header.table[3]},
];

const columns_gpa = [
    {name: "filename", title: "File"},
    {name: "download", title: "Open file"},
];

const columns_afinz = [
    {name: "card", title: "ID card"},
    {name: "url_courier", title: "Link Courier"},
    {name: "url_prazos", title: "Link Prazos"}
];
const columns_cea = [
    {name: "id_pedido", title: "Id pedido"},
    {name: "url_produto", title: "Open link"}
];

const columns_cupcake = [
    {name: "id_produto", title: "Id produto"},
    {name: "url_produto", title: "Open link"}
];

const columns_ccr = [
    {name: "rodovia", title: "Rodovia"}
];


class Explorer extends Component {

    state = {
        dataArray: [],
        form: {
            search: "",
            exactPh: false,
            start: 0,
            pageSize: 20,
            page: 1,
        }
    };

    async onSubmitForm(data) {
        await this.setState(prevState => ({
            form: {
                ...prevState.form,
                search: data.search,
                exactPh: data.exactPh,
                pageSize: 20,
                page: 1,
            }
        }))


        //await this.props.fetchDataCount(this.state.form);
        this.props.fetchData(this.state.form);

    }

    getHighlightedText = (text, highlight) => {
        if (!highlight.trim()) {
            return text;
        }
        //highlight = highlight.replace(/ +/gi, "|");

        const regex = new RegExp(`(${highlight})`, "gi");
        const parts = text.split(regex);
        const updatedParts = parts
            .filter((part) => part)
            .map((part, i) =>
                regex.test(part) ?
                    <mark style={{backgroundColor: "#f9efbd!important"}} key={i}><strong>{part}</strong></mark> : part
            );
        let newText = "";
        [...updatedParts].map(
            (parts) =>
                (newText =
                    newText +
                    (typeof parts === "object"
                        ? `<${parts["type"]}>${highlight}</${parts["type"]}>`
                        : parts))
        );
        return newText;
    };

    async onChangePagination(arg1, arg2, arg3) {
        await this.setState(prevState => ({
            form: {
                ...prevState.form,
                start: this.state.form.start == 0 ? (arg1.page * arg1.pageSize) - 20 : this.state.form.start * arg1.page,
                pageSize: arg1.pageSize,
                page: arg1.page,
            }
        }))
        await this.props.fetchData(this.state.form);
    }

    render() {
        let {data, isLoading} = this.props;

        let rows = [];
        let colunas = "";
        let rowsExpanded = [];
//https://view.officeapps.live.com/op/view.aspx?src=
        if (process.env.REACT_APP_ARMEN_THEME == 'gpa') {
            colunas = columns_gpa;
            rows =
                data?.length > 0
                    ? data.map(execution => {
                        return {
                            ...execution,
                            id: execution._id,
                            filename: execution.bucket ? execution.bucket : "No file attached",
                            parentId: null,
                            download: execution.type == "excel" ? <div className="text-center" style={{color: "#c6c6c6"}}>
                                    <a href={"https://view.officeapps.live.com/op/view.aspx?src=" + execution.linktoopen}
                                       target={"_blank"}> <Launch20 size="small"/></a>
                                </div> :
                                <div className="text-center" style={{color: "#c6c6c6"}}>
                                    <a href={execution.linktoopen} target={"_blank"}> <Launch20 size="small"/></a>
                                </div>

                        };
                    })
                    : [];
            rowsExpanded = rows?.length > 0
                ? rows.map(exec => {
                    return exec.id
                }) : [];
        } else if (process.env.REACT_APP_ARMEN_THEME == 'credz') {
            colunas = columns;
            rows =
                data?.length > 0
                    ? data.map(execution => {
                        return {
                            ...execution,
                            id: execution._id,
                            filename: execution.filename,
                            text: this.getHighlightedText(execution.texto, this.state.form.search),
                            parentId: null,
                            download:
                                <div className="text-center" style={{color: "#c6c6c6"}}>
                                    <Download20 size="small"/>
                                </div>

                        };
                    })
                    : [];
            rowsExpanded = rows?.length > 0
                ? rows.map(exec => {
                    return exec.id
                }) : [];
        } else if (process.env.REACT_APP_ARMEN_THEME == 'afinz') {
            colunas = columns_afinz;
            rows =
                data?.length > 0
                    ? data.map(execution => {
                        return {
                            ...execution,
                            id: execution._id,
                            card: execution.id_cartao ? execution.id_cartao : "No id card",
                            parentId: null,
                            url_prazos: <div className="text-center" style={{color: "#c6c6c6"}}>
                                    <a href="https://sorocredcombina.sharepoint.com/sites/Afinz/SitePages/Cartão--.aspx"
                                       target={"_blank"}> <Launch20 size="small"/></a>
                                </div>,
                            url_courier: execution.url ? <div className="text-center" style={{color: "#c6c6c6"}}>
                                    <a href={execution.url}
                                       target={"_blank"}> <Launch20 size="small"/></a>
                                </div> :
                                <div className="text-center">
                                    <Launch20 size="small"/>
                                </div>
                        };
                    })
                    : [];

            rowsExpanded = rows?.length > 0
                ? rows.map(exec => {
                    return exec.id
                }) : [];

        } else if (process.env.REACT_APP_ARMEN_THEME == 'cea') {
            colunas = columns_cea;
            rows =
                data?.length > 0
                    ? data.map(execution => {
                        return {
                            ...execution,
                            id: execution._id,
                            parentId: null,
                            url_produto: execution.url_produto ? <div className="text-center" style={{color: "#c6c6c6"}}>
                                    <a href={execution.url_produto}
                                       target={"_blank"}> <Launch20 size="small"/></a>
                                </div> :
                                <div className="text-center">
                                    <Launch20 size="small"/>
                                </div>
                        };
                    })
                    : [];
            rowsExpanded = rows?.length > 0
                ? rows.map(exec => {
                    return exec.id
                }) : [];
        } else if (process.env.REACT_APP_ARMEN_THEME == 'cupcakevox') {
            colunas = columns_cupcake;
            rows =
                data?.length > 0
                    ? data.map(execution => {
                        return {
                            ...execution,
                            id: execution._id,
                            parentId: null,
                            url_produto: execution.url_produto ? <div className="text-center" style={{color: "#c6c6c6"}}>
                                    <a href={execution.url_produto}
                                       target={"_blank"}> <Launch20 size="small"/></a>
                                </div> :
                                <div className="text-center">
                                    <Launch20 size="small"/>
                                </div>
                        };
                    })
                    : [];
            rowsExpanded = rows?.length > 0
                ? rows.map(exec => {
                    return exec.id
                }) : [];
        } else if (process.env.REACT_APP_ARMEN_THEME == 'ccr') {
            colunas = columns_ccr;
            rows =
                data?.length > 0
                    ? data.map(execution => {
                        return {
                            ...execution,
                            id: execution._id,
                            parentId: null,
                        };
                    })
                    : [];
            rowsExpanded = rows?.length > 0
                ? rows.map(exec => {
                    return exec.id
                }) : [];
        }


        return (
            <React.Fragment>
                <Layout>
                    <Grid class="painel" fullWidth>
                        <div className="header-text header-text-report">
                            <h5>{leng.sideBar.intelligentJourney.title}</h5>
                            <h3>Explorer</h3>
                        </div>

                        <div>
                            <FilterSearch
                                form={this.state.form}
                                onSubmitForm={(data) => this.onSubmitForm(data)}
                            />
                        </div>

                        <div>
                            {isLoading ? (
                                <div style={{paddingTop: "20px", paddingRight: "20px"}}>
                                    <DataTableSkeleton/>
                                </div>
                            ) : (
                                <>
                                    {this.state.form.search == "" && (rows.length == 0) ? ('') :
                                        (
                                            <>
                                                {(rows.length == 0) ? (
                                                    <div style={{paddingTop: "20px", marginRight: "40px"}}>


                                                        <div className="section-light-heading">
                                                            <div className="file-upload-container">
                                                                <div className="MuiPaper-root div-header-border"
                                                                     style={{
                                                                         minHeight: "100px",
                                                                         backgroundColor: "#FFF"
                                                                     }}>
                                                                    <div style={{
                                                                        paddingTop: "16px",
                                                                        paddingLeft: "26px",
                                                                        fontSize: "20px",
                                                                        color: "#161616"
                                                                    }}>Sorry, no results found.
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>


                                                    </div>
                                                ) : (
                                                    <div style={{
                                                        paddingTop: "20px",
                                                        paddingRight: "20px",
                                                        paddingBottom: "80px"
                                                    }}>
                                                        <CustomTable headerInformation={headerInformation}
                                                                     columns={colunas}
                                                                     rowsData={rows}
                                                                     rowDetail={data.length > 0 ? true : false}
                                                                     Headertext={"Results"}
                                                                     headerDescription={false}
                                                                     fixedColumns={false}
                                                                     editable={false}
                                                                     getRemoteRows={rows}
                                                                     defaultExpandedRowIds={rowsExpanded}
                                                        />
                                                        <Pagination
                                                            className="paginator"

                                                            pageSizes={[20, 40]}
                                                            backwardText="Previous"
                                                            forwardText="Next"
                                                            pagesUnknown={true}
                                                            pageInputDisabled={true}
                                                            pageSize={this.state.form.pageSize}
                                                            page={this.state.form.page}
                                                            onChange={(arg1, arg2, arg3) => {
                                                                this.onChangePagination(arg1, arg2, arg3);
                                                            }}
                                                        ></Pagination>
                                                    </div>
                                                )}

                                            </>)
                                    }
                                </>
                            )}


                        </div>
                    </Grid>
                </Layout>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({explorer}) => explorer;

const mapDispatchToProps = dispatch => ({
    fetchData: (form) => dispatch(explorer_action_search(form)),
    // fetchDataCount: (form) => dispatch(explorer_action_search_count(form)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Explorer);
